import { default as i18n } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import ChainedBackend from 'i18next-chained-backend'
import Backend from 'i18next-http-backend'
import resourcesToBackend from 'i18next-resources-to-backend'
import { initReactI18next } from 'react-i18next'

i18n
  .use(ChainedBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    load: 'languageOnly',
    ns: ['translation', 'common'],
    defaultNS: 'translation',
    fallbackNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      backends: [
        Backend, // Load funnel-specific translations from public folder
        resourcesToBackend((language: string, namespace: string) => {
          // Only load common namespace from shared package
          if (namespace === 'common') {
            return import(
              `@app-studio-web/translations/locales/${language}/common.json`
            )
          }
          // Return undefined for namespaces we don't handle
          return undefined
        }),
      ],
      backendOptions: [
        {
          loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
      ],
    },
  })
  .catch((error) => console.error(error))

const syncHtmlLang = (language: string) => {
  if (typeof document === 'undefined' || !language) return
  document.documentElement.lang = language
}

syncHtmlLang(i18n.language)
i18n.on('languageChanged', syncHtmlLang)

export default i18n
